function makeRemote(defaultConfig, extraConfigGenerator) {
  return (axiosInstance) => {
    const remoteFn = extraConfigGenerator === void 0 ? (options) => axiosInstance.request({ ...defaultConfig, ...options }) : (params, options) => axiosInstance.request({
      ...defaultConfig,
      ...extraConfigGenerator(params),
      ...options
    });
    if (extraConfigGenerator !== void 0) {
      if ("url" in defaultConfig) {
        return [
          remoteFn,
          defaultConfig,
          extraConfigGenerator
        ];
      }
      return [
        remoteFn,
        defaultConfig,
        extraConfigGenerator
      ];
    }
    return [remoteFn, defaultConfig];
  };
}
function makeRemoteWithOpenapiGenerator(generatorParams) {
  return (axiosInstance) => {
    if ("requestArgs" in generatorParams) {
      const value = [
        (_, options) => generatorParams.requestFn(options)(axiosInstance),
        generatorParams.requestArgs
      ];
      return value;
    } else {
      const value = [
        (params, options) => generatorParams.requestFn(params, options)(axiosInstance),
        {},
        (params) => generatorParams.requestArgsCreator(params)
      ];
      return value;
    }
  };
}

export { makeRemote, makeRemoteWithOpenapiGenerator };
//# sourceMappingURL=generators.mjs.map
